import { useSelector } from "react-redux";
import { useMemo } from "react";

export default function useIsG2powerIv(SelInverter) {
  const Iv_list = useSelector((state) => state.Iv_list || {});

  const isG2power = useMemo(() => {
    if (!Iv_list.seq || !Array.isArray(Iv_list.seq)) return false;
    const index = Iv_list.seq.findIndex((seq) => seq === SelInverter);
    const protocol = Iv_list.iv_protocol?.[index] || "";
    return protocol.toUpperCase() === "G2POWER_INV";
  }, [Iv_list, SelInverter]);

  return isG2power;
}

